
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("fnuwx"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("fnuwx", function(module, exports) {

let $b320ae5f68456044$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b320ae5f68456044$var$load("dIzOY"),
    $b320ae5f68456044$var$load("alXrq"),
    $b320ae5f68456044$var$load("2YffH"),
    $b320ae5f68456044$var$load("iDB1L"),
    $b320ae5f68456044$var$load("1aTst"),
    $b320ae5f68456044$var$load("eEyVs"),
    $b320ae5f68456044$var$load("6mHrv"),
    $b320ae5f68456044$var$load("awWN9"),
    $b320ae5f68456044$var$load("9CYct"),
    $b320ae5f68456044$var$load("iIoyG"),
    $b320ae5f68456044$var$load("2xn4F"),
    $b320ae5f68456044$var$load("hZtKG"),
    $b320ae5f68456044$var$load("iNmaF"),
    $b320ae5f68456044$var$load("lVO3w"),
    $b320ae5f68456044$var$load("hyzoX"),
    $b320ae5f68456044$var$load("h9Ed7"),
    $b320ae5f68456044$var$load("eBRUf"),
    $b320ae5f68456044$var$load("bogQM"),
    $b320ae5f68456044$var$load("jq3Ai"),
    $b320ae5f68456044$var$load("bv7z8"),
    $b320ae5f68456044$var$load("8A3nE"),
    $b320ae5f68456044$var$load("8YSo7"),
    $b320ae5f68456044$var$load("g7ggm"),
    $b320ae5f68456044$var$load("9S9Mz"),
    $b320ae5f68456044$var$load("kiGNy"),
    $b320ae5f68456044$var$load("7do1E"),
    $b320ae5f68456044$var$load("77dkW"),
    $b320ae5f68456044$var$load("arCL2"),
    $b320ae5f68456044$var$load("g9CVe"),
    $b320ae5f68456044$var$load("6iz6l"),
    $b320ae5f68456044$var$load("4SCW2"),
    $b320ae5f68456044$var$load("855o0"),
    $b320ae5f68456044$var$load("8MfZE"),
    $b320ae5f68456044$var$load("hv4mn"),
    $b320ae5f68456044$var$load("dek7I"),
    $b320ae5f68456044$var$load("3SmkN"),
    $b320ae5f68456044$var$load("dYtBN"),
    $b320ae5f68456044$var$load("kNV5Y"),
    $b320ae5f68456044$var$load("6wr18"),
    $b320ae5f68456044$var$load("kjZZD"),
    $b320ae5f68456044$var$load("bkc7o"),
    $b320ae5f68456044$var$load("2wlUS"),
    $b320ae5f68456044$var$load("9u7sS"),
    $b320ae5f68456044$var$load("1fem1"),
    $b320ae5f68456044$var$load("Wowvf"),
    $b320ae5f68456044$var$load("ffEVr"),
    $b320ae5f68456044$var$load("hhss7"),
    $b320ae5f68456044$var$load("dTsOE"),
    $b320ae5f68456044$var$load("kquhK"),
    $b320ae5f68456044$var$load("drtqM"),
    $b320ae5f68456044$var$load("henq4"),
    $b320ae5f68456044$var$load("eylda"),
    $b320ae5f68456044$var$load("8TDGF"),
    $b320ae5f68456044$var$load("8fMw3"),
    $b320ae5f68456044$var$load("hogcU"),
    $b320ae5f68456044$var$load("dAdaw"),
    $b320ae5f68456044$var$load("h3ABO"),
    $b320ae5f68456044$var$load("kC80R"),
    $b320ae5f68456044$var$load("7EorR"),
    $b320ae5f68456044$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.45092155.js.map
